import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider, QueryClient } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import 'bootstrap/dist/css/bootstrap.css';
import './styles/index.scss';
import { initRuntimeConfig } from './helpers/fetchConfig';
import reportWebVitals from './reportWebVitals';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      suspense: false,
      refetchOnWindowFocus: false,

      useErrorBoundary: true,
    },
    mutations: {
      useErrorBoundary: true,
    },
  },
});

// initRuntimeConfig must complete before AuthService is constructed
// (App.tsx → AuthService → UserManager reads getIdentityConfig at that moment).
// Dynamic import of App defers its module-level `new AuthService()` until
// the runtime config has been fetched.
initRuntimeConfig().then(async () => {
  const { default: App } = await import('./App');
  ReactDOM.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
        <ReactQueryDevtools />
      </QueryClientProvider>
    </React.StrictMode>,
    document.getElementById('location_profile')
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
